define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {
});
